<script lang="ts">
	//Design system components
	import { Text, Container, ControlsContainer } from '@Shelly/shelly-design-system';
	//Components
	import TimePickerWrapper from '../../../../components/TimePicker/TimePickerWrapper.svelte';
	import TypeSelector from '../SchedulesHelpers/TypeSelector.svelte';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	// Helpers
	import { modeTypes } from '../SchedulesHelpers/schedules';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	const scheduleStore: SvelteStore<any> = getContext('schedule');
	const dispatch = createEventDispatcher();

	let time = $scheduleStore.time;
	let hoursRange = $scheduleStore.hoursRange;
	let mode = $scheduleStore.mode;

	const changeTime = (e) => {
		time = e.detail;
		dispatch('update', { time });
	};

	const changeMode = (e) => {
		mode = e.detail;
		hoursRange = e.detail !== modeTypes.time ? [0, 12] : [0, 23];
		dispatch('update', {
			mode,
		});
		dispatch('update', {
			hoursRange: e.detail !== modeTypes.time ? [0, 12] : [0, 23],
		});
	};
</script>

<Container padding="scrollPaddings">
	<Text class="mb-s" element="h2">{$format('choose_time_interval')}</Text>

	<TypeSelector {mode} on:change={changeMode} />

	<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
		<TimePickerWrapper
			slot="first"
			{hoursRange}
			{time}
			{mode}
			on:change={changeTime}
			on:change-mode={changeMode}
		/>
	</ControlsContainer>
</Container>
